<template>
  <div class="sezione "  style="padding:0 20px;">
<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Admin</el-breadcrumb-item>
         <el-breadcrumb-item>Centro</el-breadcrumb-item>
         <el-breadcrumb-item>Modifica</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>
<div >
<div class="title_h1 yo-color-primary" style="margin-top:30px;">AMMINISTRAZIONE CENTRI</div>
<br />
In questa sezione potete gestire le attivazione dei vari centri e i dati del VON
</div>
   
<centroCerca  v-if="$teras._centro.length>0"></centroCerca>




  </div>
</template>

<script>
import centroCerca from './Centro-cerca.vue'
//import schedeInlavorazione from './Schede-inlavorazione.vue'
//import schedeChiusa from './Schede-chiusa.vue'
export default {
  components: {
    centroCerca
    //schedeInlavorazione
    //,schedeChiusa
   }
}
</script>

